import Layout from 'bento-ordering/base/layouts/BaseLayout';
import GroupOrderSettingsModal from 'bento-ordering/group_ordering/components/GroupOrderSettingsModal';
import GroupOrderInviteModal from 'bento-ordering/group_ordering/components/GroupOrderInviteModal';
import GroupOrderJoinModal from 'bento-ordering/group_ordering/components/GroupOrderJoinModal';
import {
  GROUP_ORDER_SETTINGS,
  GROUP_ORDER_INVITE,
  GROUP_ORDER_JOIN
} from 'bento-ordering/group_ordering/constants/paths';

const routes = [
  {
    path: GROUP_ORDER_SETTINGS,
    exact: true,
    Component: GroupOrderSettingsModal,
    Layout
  },
  {
    path: GROUP_ORDER_INVITE,
    exact: true,
    Component: GroupOrderInviteModal,
    Layout
  },
  {
    path: GROUP_ORDER_JOIN,
    exact: true,
    Component: GroupOrderJoinModal,
    Layout
  }
];

export default routes;
